import { DatoLegajo, Legajo, LegajoItem } from '@/shared/model/legajo/legajo.model';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class DetalleLegajoComponent extends Vue {
  @Prop({
    required: false,
    default: function () {
      return new Legajo();
    },
  })
  public legajo!: Legajo;

  public mostrarDetalles = false;

  @Watch('legajo', { immediate: true })
  public watchLegajo(): void {
    if (!!this.legajo.id) {
      this.mostrarDetalles = true;
    } else {
      this.mostrarDetalles = false;
    }
  }

  @Emit('detallesOcultos')
  public cerrarDetalles(): void {
    this.mostrarDetalles = false;
  }

  get itemsFiltrados(): Array<LegajoItem> {
    return (this.legajo.items ?? []).filter(item => item.visible);
  }

  get datos(): Array<DatoLegajo> {
    const datos = this.legajo.datos ?? {};
    return Object.keys(datos).map((key: string) => new DatoLegajo(key, datos[key as keyof object]));
  }
}
